//@ts-check
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import withAuth from '../../../../../core/EcrionProvider/boot/withAuth';
import Page from '../../../../../page';
import Utils from '../../../../../utils';
/**
 * @param {import('./types').JobFinishedProps} props
 */

var OutputDownloaded = function OutputDownloaded(_ref) {
  var job = _ref.job,
      project = _ref.project,
      auth = _ref.auth;
  React.useEffect(function () {
    var token = auth && auth.token;
    var apiUrl = "".concat(Utils.getHost(), "backend/communicationoutput?accessToken=").concat(token, "&communication=").concat(project.Name, "&jobId=").concat(job.Id);
    window.location.replace(apiUrl);
  }, []);
  return React.createElement(React.Fragment, null, React.createElement(Page.Common, {
    margin: "none",
    navBarHidden: true
  }, React.createElement(Grid, {
    container: true,
    direction: "column",
    alignItems: "center",
    justify: "center",
    style: {
      minHeight: 'calc(100vh - 160px)',
      textAlign: 'center'
    }
  }, React.createElement(Grid, {
    item: true,
    xs: 6
  }, React.createElement(Grid, {
    container: true,
    direction: "column",
    alignItems: "center"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Typography, {
    variant: "h6"
  }, "The result was successfully generated and downloaded.")))))));
};

export default withAuth(OutputDownloaded);